import { Types } from '../../constants/announcementTypes';

export function useAnnouncementValidation(values, isEditing = false) {
  const errors = {};

  if (values.activeTab === Types.Recents) {
    if (!values.selectedManualId) {
      errors.selectedManualId = 'Selecciona un manual antes de publicar.';
    }
  }

  if ([Types.Image, Types.Pdf, Types.Video].includes(values.activeTab)) {
    // Si estamos editando, permitimos que selectedFile sea null si hay previewUrl
    if (!isEditing) {
      // Para creación: siempre requerir archivo
      if (!values.selectedFile) {
        errors.selectedFile = 'Debes seleccionar un archivo antes de publicar.';
      }
    } else {
      // Para edición: requerir archivo solo si no hay previewUrl
      if (!values.selectedFile && !values.previewUrl) {
        errors.selectedFile = 'Debes seleccionar un archivo antes de publicar.';
      }
    }
    
    if (!values.title?.trim()) {
      errors.title = 'El título es obligatorio.';
    }
    if (!values.summary?.trim()) {
      errors.summary = 'El resumen es obligatorio.';
    }
  }

  if (values.activeTab === Types.Advertisement) {
    if (!values.selectedIcon) {
      errors.selectedIcon = 'Debes escoger un ícono.';
    }
    if (!values.editorText.replace(/<(.|\n)*?>/g, '').trim()) {
      errors.editorText = 'La descripción es obligatoria.';
    }
  }

  if (new Date(values.fromDate) > new Date(values.toDate)) {
    errors.dateRange = 'La fecha de inicio debe ser anterior o igual a la fecha de fin.';
  }

  const isValid = Object.keys(errors).length === 0;
  return { isValid, errors };
}

export function republishValidation(values) {
  const errors = {};

  if (new Date(values.fromDate) > new Date(values.toDate)) {
    errors.dateRange = 'La fecha de inicio debe ser anterior o igual a la fecha de fin.';
  }

  const isValid = Object.keys(errors).length === 0;
  
  return { isValid, errors };
}